var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPathintechlogoV2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1224,
    height: 397,
    viewBox: "0 0 1224 397",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M764.992 74.4651C764.992 84.9179 762.481 94.7683 757.459 104.046C752.469 113.294 744.477 120.825 733.454 126.639C722.431 132.468 708.301 135.375 691.077 135.375H653.232V218.696H619V13.2544H691.077C707.122 13.2544 720.686 15.9655 731.801 21.3877C742.9 26.8099 751.213 34.16 756.725 43.438C762.236 52.6859 764.992 63.0182 764.992 74.4651ZM691.077 107.842C704.09 107.842 713.812 104.95 720.227 99.1663C726.626 93.3525 729.841 85.1137 729.841 74.4651C729.841 52.0232 716.92 40.7872 691.077 40.7872H653.232V107.842H691.077Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M772.813 136.519C772.813 120.177 776.258 105.703 783.163 93.0814C790.052 80.4747 799.467 70.6696 811.394 63.6809C823.304 56.6923 836.471 53.198 850.892 53.198C863.905 53.198 875.28 55.7133 885.002 60.7288C894.708 65.7595 902.47 71.995 908.272 79.4656V55.8489H942.811V218.696H908.272V194.477C902.47 202.158 894.555 208.559 884.512 213.695C874.499 218.786 863.094 221.347 850.28 221.347C836.073 221.347 823.044 217.762 811.21 210.563C799.406 203.378 790.052 193.332 783.163 180.439C776.258 167.516 772.813 152.876 772.813 136.519ZM908.272 137.122C908.272 125.886 905.915 116.126 901.23 107.842C896.53 99.573 890.36 93.2621 882.736 88.9243C875.142 84.5866 866.937 82.4177 858.118 82.4177C849.3 82.4177 841.063 84.5564 833.439 88.8038C825.846 93.0211 819.691 99.2265 815.007 107.42C810.307 115.584 807.964 125.283 807.964 136.519C807.964 147.77 810.307 157.636 815.007 166.1C819.691 174.58 825.907 181.027 833.623 185.44C841.339 189.868 849.499 192.067 858.118 192.067C866.937 192.067 875.142 189.928 882.736 185.62C890.36 181.283 896.53 174.942 901.23 166.582C905.915 158.193 908.272 148.373 908.272 137.122Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.27 83.3214V173.451C1014.27 179.566 1015.7 183.964 1018.61 186.645C1021.55 189.295 1026.51 190.621 1033.49 190.621H1054.56V218.696H1027.49C1012.09 218.696 1000.27 215.171 992.036 208.092C983.83 200.983 979.727 189.446 979.727 173.451V83.3214H960.192V55.8489H979.727V15.363H1014.27V55.8489H1054.56V83.3214H1014.27Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1158.17 53.1979C1170.78 53.1979 1182.05 55.8789 1191.97 61.2107C1201.89 66.5124 1209.7 74.3897 1215.43 84.8275C1221.14 95.2803 1224 107.887 1224 122.662V218.696H1190.01V127.663C1190.01 113.083 1186.29 101.907 1178.87 94.1055C1171.47 86.3186 1161.37 82.4176 1148.55 82.4176C1135.73 82.4176 1125.56 86.3186 1118.06 94.1055C1110.54 101.907 1106.79 113.083 1106.79 127.663V218.696H1072.56V0H1106.79V74.7662C1112.62 67.868 1119.99 62.5362 1128.9 58.8009C1137.79 55.0656 1147.54 53.1979 1158.17 53.1979Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M629.871 260.902C626.932 260.902 624.39 259.878 622.277 257.83C620.195 255.782 619.154 253.251 619.154 250.239C619.154 247.226 620.195 244.741 622.277 242.768C624.39 240.765 626.932 239.756 629.871 239.756C632.764 239.756 635.26 240.765 637.342 242.768C639.455 244.741 640.526 247.226 640.526 250.239C640.526 253.251 639.455 255.782 637.342 257.83C635.26 259.878 632.764 260.902 629.871 260.902ZM637.158 282.109V394.409H622.522V282.109H637.158Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M714.508 280.061C728.179 280.061 739.325 284.218 747.944 292.532C756.594 300.816 760.927 312.835 760.927 328.62V394.409H746.474V330.247C746.474 318.047 743.366 308.723 737.166 302.292C730.996 295.831 722.546 292.592 711.814 292.592C700.791 292.592 691.988 296.026 685.42 302.895C678.883 309.733 675.622 319.809 675.622 333.138V394.409H660.986V282.109H675.622V301.208C679.25 294.385 684.471 289.158 691.299 285.543C698.111 281.899 705.843 280.061 714.508 280.061Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M869.395 250.661V262.59H828.855V394.409H814.219V262.59H773.435V250.661H869.395Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M986.514 332.476C986.514 337.416 986.361 341.197 986.086 343.802H891.35C891.794 352.327 893.892 359.587 897.658 365.612C901.409 371.636 906.354 376.2 912.477 379.288C918.601 382.39 925.291 383.927 932.563 383.927C942.025 383.927 949.986 381.682 956.446 377.179C962.938 372.645 967.24 366.515 969.368 358.804H984.8C982.013 369.769 976.058 378.73 966.918 385.674C957.809 392.587 946.357 396.036 932.563 396.036C921.816 396.036 912.186 393.687 903.659 388.987C895.162 384.258 888.503 377.525 883.695 368.805C878.919 360.099 876.531 349.917 876.531 338.26C876.531 326.617 878.888 316.42 883.634 307.654C888.365 298.858 894.979 292.141 903.475 287.472C912.003 282.817 921.694 280.483 932.563 280.483C943.418 280.483 952.925 282.817 961.1 287.472C969.26 292.141 975.522 298.406 979.901 306.269C984.31 314.146 986.514 322.882 986.514 332.476ZM971.633 332.114C971.786 323.725 970.102 316.601 966.551 310.727C962.999 304.823 958.13 300.364 951.976 297.352C945.852 294.31 939.177 292.773 931.951 292.773C921.051 292.773 911.758 296.207 904.088 303.075C896.448 309.944 892.207 319.628 891.35 332.114H971.633Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M997.152 338.26C997.152 326.617 999.51 316.435 1004.26 307.714C1008.99 299.009 1015.54 292.291 1023.91 287.592C1032.27 282.863 1041.83 280.483 1052.57 280.483C1066.61 280.483 1078.2 283.917 1087.36 290.785C1096.5 297.623 1102.37 306.931 1104.99 318.74H1089.32C1087.39 310.636 1083.19 304.28 1076.7 299.702C1070.21 295.093 1062.16 292.773 1052.57 292.773C1044.89 292.773 1037.97 294.505 1031.81 297.954C1025.69 301.373 1020.85 306.479 1017.3 313.257C1013.75 320.05 1011.97 328.379 1011.97 338.26C1011.97 348.14 1013.75 356.514 1017.3 363.382C1020.85 370.22 1025.69 375.357 1031.81 378.806C1037.97 382.225 1044.89 383.927 1052.57 383.927C1062.16 383.927 1070.21 381.637 1076.7 377.058C1083.19 372.45 1087.39 366.018 1089.32 357.78H1104.99C1102.37 369.317 1096.45 378.565 1087.23 385.553C1078.05 392.542 1066.49 396.036 1052.57 396.036C1041.83 396.036 1032.27 393.687 1023.91 388.987C1015.54 384.258 1008.99 377.525 1004.26 368.805C999.51 360.099 997.152 349.917 997.152 338.26Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1176.95 280.061C1185.55 280.061 1193.31 281.853 1200.22 285.423C1207.11 288.962 1212.54 294.4 1216.51 301.75C1220.5 309.1 1222.51 318.061 1222.51 328.62V394.409H1208.06V330.246C1208.06 318.046 1204.95 308.723 1198.75 302.292C1192.58 295.83 1184.13 292.592 1173.4 292.592C1162.37 292.592 1153.57 296.026 1147 302.894C1140.46 309.732 1137.2 319.809 1137.2 333.138V394.409H1122.57V242.226H1137.2V301.207C1140.83 294.505 1146.16 289.309 1153.19 285.604C1160.24 281.913 1168.16 280.061 1176.95 280.061Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 371C2.23858 371 0 373.239 0 376V391C0 393.761 2.23857 396 5 396H595C597.761 396 600 393.761 600 391V376C600 373.239 597.761 371 595 371H345L341.044 379H258.956L255 371H5Z",
    fill: "#583FA7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65 14C56.7157 14 50 20.7157 50 29V345C50 353.284 56.7157 360 65 360H80.0594L390.052 183.274L392.676 180.612L393.821 177.254V173.692L392.676 170.498L387.952 167.305L77.2484 65.1015L75.149 64.0369L73.0497 61.9077L72 57.6492L72.5248 54.4554L73.5745 51.7938L75.149 50.1969L77.2484 48.6L179.067 14H65ZM195.862 14L154.4 43.2769L150.201 47.0031L149.151 49.1323V51.7938L150.201 53.9231L151.251 54.9877L153.875 56.5846L236.868 79.9936L468.778 137.495L487.147 144.415L498.793 151.147L505.516 156.126L511.814 161.982L516.538 167.837L520.737 174.757L524.41 184.338L526.51 191.791L527.559 200.289V204.034V208.292L527.035 212.551L525.985 216.277L477.597 360H535C543.284 360 550 353.284 550 345V29C550 20.7157 543.284 14 535 14H195.862Z",
    fill: "url(#paint0_radial_30_240)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_30_240",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9987 14.0014) scale(602.683 620.732)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6269D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#6268D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#6268D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#6167D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507812,
    stopColor: "#6167D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#6166D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#6166D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#6165D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976562,
    stopColor: "#6165D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#6164D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#6164CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132812,
    stopColor: "#6163CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#6063CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#6062CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#6062CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#6061CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#6061CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#6060CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#6060CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226562,
    stopColor: "#605FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#5F5FCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#5F5EC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#5F5EC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#5F5DC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#5F5CC7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320312,
    stopColor: "#5F5BC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#5E5AC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#5E5AC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#5E59C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#5E58C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#5E57C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#5E57C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#5D56C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#5D55C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#5D55BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#5D54BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#5D54BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#5D53BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#5D53BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539062,
    stopColor: "#5D52BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#5C52BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#5C51BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#5C51BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#5C50BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#5C50B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#5C4FB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#5C4FB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632812,
    stopColor: "#5C4EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#5B4DB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#5B4CB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#5B4CB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#5B4BB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#5B4AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#5A4AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#5A49B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#5A49B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#5A48B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789062,
    stopColor: "#5A48B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#5A47B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#5A47AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#5A46AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#5945AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#5944AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#5944AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#5943AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#5943AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914062,
    stopColor: "#5942AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#5941AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#5841A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#5840A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#583FA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583FA7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathintechlogoV2);
export default __webpack_public_path__ + "static/media/pathintechlogoV2.236d0650b13a68c61f0aef7c088d6134.svg";
export { ForwardRef as ReactComponent };